import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

export const Footer = () => (
  <footer className="mt-24 border-t border-border/60 bg-muted/30" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3">
          <img
            src="/logo-icon.png"
            alt="StaffLink Ghana"
            className="h-12 w-auto object-contain"
          />
          <div>
            <div className="font-display font-bold">StaffLink Ghana</div>
            <div className="text-xs text-muted-foreground uppercase tracking-widest">Business Automation</div>
          </div>
        </div>
        <p className="mt-4 text-sm text-muted-foreground max-w-md">
          We build automation that saves growing businesses time, money and stress —
          from AI receptionists to full executive dashboards.
        </p>
      </div>
      <div>
        <div className="font-display font-semibold mb-3">Demos</div>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li><Link to="/demo/receptionist" className="hover:text-foreground transition-colors">AI Receptionist</Link></li>
          <li><Link to="/demo/crm" className="hover:text-foreground transition-colors">CRM Automation</Link></li>
          <li><Link to="/demo/appointments" className="hover:text-foreground transition-colors">Appointment Booking</Link></li>
          <li><Link to="/demo/invoicing" className="hover:text-foreground transition-colors">Quotation & Invoice</Link></li>
          <li><Link to="/demo/analytics" className="hover:text-foreground transition-colors">Executive Analytics</Link></li>
        </ul>
      </div>
      <div>
        <div className="font-display font-semibold mb-3">Contact</div>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li className="flex items-center gap-2"><MapPin className="w-4 h-4"/> Accra, Ghana</li>
          <li className="flex items-center gap-2"><Phone className="w-4 h-4"/> +233 59 982 7348</li>
          <li className="flex items-center gap-2"><Mail className="w-4 h-4"/> hello@stafflinkgh.com</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border/60 py-4 text-center text-xs text-muted-foreground">
      © {new Date().getFullYear()} StaffLink Ghana. All rights reserved.
    </div>
  </footer>
);

export default Footer;
